<mibi-box-layout>
  <div class="mibi-banner">
    <div class="mibi-banner__message">
      <div class="mibi-banner-message">
        <mat-icon class="mibi-banner-message__icon"
          [ngClass]="{
            'mibi-banner-message__icon--success': banner.type === 'success',
            'mibi-banner-message__icon--error': banner.type === 'error',
            'mibi-banner-message__icon--warning': banner.type === 'warning'
          }"
        >
          {{banner.icon}}
        </mat-icon>
        <div class="mibi-banner-message__text" [innerHTML]="banner.message"></div>
      </div>
    </div>
    <div class="mibi-banner__actions">
      <div class="mibi-banner-actions">
        <button *ngIf="!!banner.auxilliaryAction" class="mibi-banner-actions__item" type="button" mat-button color="accent"
          (click)="onAuxAction()">{{banner.auxilliaryAction.label}}</button>
        <button class="mibi-banner-actions__item" type="button" mat-button color="accent"
          (click)="onMainAction()">{{banner.mainAction.label}}</button>
      </div>
    </div>
  </div>
</mibi-box-layout>